import axios from 'axios';
import { API_URL, config } from '../../../config/config';

// Service for getting Stoke
// const getStock = async (data, page) => {
// 	const response = await axios.post(`${API_URL}/stock/fetchstock/?page=${page}`, data, config);
    
	
// 	return response.data;
// };

const getFetchStock = async (data, page) => {
	const response = await axios.post(`${API_URL}/addStock/FetchstockData/?page=${page}`, data, config);
	return response.data;
};
const getFetchStockTable = async (data, page) => {
	const response = await axios.post(`${API_URL}/addStock/fetchStockTableData/?page=${page}`, data, config);
	

	
	return response.data;
};
const getFetchStockTableForAdmin = async (data, page) => {
	const response = await axios.post(`${API_URL}/addStock/fetchStockTableData/?page=${page}`, data, config);
	

	return response.data;
};
const getFetchStockDetailTable = async (ArticleCode) => {
	
	
    const response = await axios.post(
        `${API_URL}/addStock/fetchStockDetailTableData`,
		{ArticleCode} , 
        config

    );


    return response.data;
};
const getFetchStockDetailTableForAdmin = async (ArticleCode) => {
	
	
    const response = await axios.post(
        `${API_URL}/addStock/fetchStockDetailTableData`,
		ArticleCode , 
        config
    );
    return response.data;
};
const getFetchCatalogImage = async (ProductId) => {
	
	
    const response = await axios.post(
        `${API_URL}/addStock/fetchCatalogImages`,
         ProductId , 
        config
    );
    
    
	
    return response.data;
};
const deleteCatalogImageById = async (Id) => {
    const response = await axios.post(
        `${API_URL}/addStock/deleteCatalogImage`, 
        { Id }, 
        config
    );
    return response.data;
};
const deleteArticleDesignById = async (Id) => {
    const response = await axios.post(
        `${API_URL}/addStock/deleteDesigns`, 
        { Id }, 
        config
    );
    return response.data;
};
const getStockById = async (Id) => {
	const response = await axios.post(`${API_URL}/stock/fetchstockbyid/${Id}`, {}, config);

	return response.data;
};
const getDropdown = async (id) => {
	const response = await axios.post(`${API_URL}/stock/FetchDropDown/${id}`, {}, config);
	return response.data;
};
const getDropdownSize = async (id) => {
	const response = await axios.post(`${API_URL}/stock/FetchDropDown/${id}`, {}, config);
	return response.data;
};
const getDropdownCategory = async (id) => {
	const response = await axios.post(`${API_URL}/stock/FetchDropDown/${id}`, {}, config);
	return response.data;
};
const getDropdownSubCategory = async (id) => {
	const response = await axios.post(`${API_URL}/stock/FetchDropDown/${id}`, {}, config);
	return response.data;
};
const getDropdownProduct = async (id) => {
	const response = await axios.post(`${API_URL}/stock/FetchDropDown/${id}`, {}, config);
	return response.data;
};
const getDropdownColor = async (id) => {
	const response = await axios.post(`${API_URL}/stock/FetchDropDown/${id}`, {}, config);
	return response.data;
};

const stockService = {
	// getStock,
	getFetchStock,
	getFetchStockTable,
	getFetchStockTableForAdmin,
	getFetchStockDetailTable,
	getFetchStockDetailTableForAdmin,
	getStockById,
	getFetchCatalogImage,
	deleteCatalogImageById,
	deleteArticleDesignById,
	getDropdownSize,
	getDropdownCategory,
	getDropdownSubCategory,
	getDropdownProduct,
	getDropdownColor,
	getDropdown,
};

export default stockService;
